function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

function inferBackendFromHost() {
    if (typeof window === 'undefined' || !window.location) return '';
    if (window.location.hostname === 'localhost') {
        return 'http://localhost:8080';
    }
    const protocol = window.location.protocol;
    const parts = window.location.hostname.split('.');
    if (parts.length >= 2 && parts[0].indexOf('api') !== 0) {
        parts[0] = parts[0] === 'multiflow' ? 'apimultiflow' : 'api' + parts[0];
        return protocol + '//' + parts.join('.');
    }
    return '';
}

export function getBackendUrl() {
    const url = getConfig('REACT_APP_BACKEND_URL');
    if (url) return url;
    if (typeof window.__getBackendBaseUrl === 'function') {
        return window.__getBackendBaseUrl();
    }
    return inferBackendFromHost();
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getFrontendPort() {
    return getConfig('SERVER_PORT');
}

export function getPrimaryColor() {
    return getConfig("REACT_APP_PRIMARY_COLOR");
}

export function getPrimaryDark() {
    return getConfig("REACT_APP_PRIMARY_DARK");
}

export function getNumberSupport() {
    return getConfig("REACT_APP_NUMBER_SUPPORT");
}